module.exports = __webpack_public_path__ + "assets/img/mecha-btn-21950430.png";